// A reuseable basic action which just passes type and data to the reducers
export default function actionTrigger(type, data) {
  return { type, data };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/actions/index.js
 **/